import { useQuery, useMutation } from "react-query";
import axios from "axios";

export async function GetDataAll(date = "") {
  const url =
    "https://script.google.com/macros/s/AKfycbz4E7TwcfQSDSTktbi5bsyCJFkSwpu4tdCxNcX0RPTDOBcBxizzfr4a84-sxUdz4OeO/exec";
  return axios.get(url);
}

// export const GetData = (date = "") => {
//   const url =
//     "https://script.google.com/macros/s/AKfycbwV_ikBGkwVwdzTIcE7hcJp7ShuZiZgtKn5nfi7dCQ_Oe_P2yDK/exec";
//   return useQuery("GetData", () =>
//     axios.get(url).then(res => {
//       return res.data;
//     })
//   );
// };
//
// export const GetEvents = (date = "") => {
//   const url =
//     "https://script.google.com/macros/s/AKfycbwV_ikBGkwVwdzTIcE7hcJp7ShuZiZgtKn5nfi7dCQ_Oe_P2yDK/exec?action=events";
//   return useQuery("GetEvents", () =>
//     axios.get(url).then(res => {
//       console.log("useQuery, res.data: ", res.data);
//       return res.data.events;
//     })
//   );
// };
//
// export const GetRequests = (eventId = "") => {
//   const url =
//     "https://script.google.com/macros/s/AKfycbwV_ikBGkwVwdzTIcE7hcJp7ShuZiZgtKn5nfi7dCQ_Oe_P2yDK/exec";
//
//   const params = `?action=requests&eventId=${eventId}`;
//   return useQuery("GetRequests", () =>
//     axios.get(url + params).then(res => {
//       console.log("useQuery, res.data: ", res.data);
//       return res.data.requests;
//     })
//   );
// };
//
// export const ApplyEvent = () => {
//   const url =
//     "https://script.google.com/macros/s/AKfycbwrLkGmR1Ad85n48BB7TcgpbAwKPSTEyF0xsnkdoaAwxxZA6P8G2ZrFBIaqui0Lq8BybQ/exec";
//
//   return useMutation(formData =>
//     axios.post(url, formData).then(res => {
//       console.log("useMutation, res.data ", res.data);
//       return res.data;
//     })
//   );
// };
